import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import * as globalConst from './../../../../constants';

// Service
import { LogService } from '../../service/log-list/log.service';

import * as moment from 'moment';
import { IMyDpOptions } from 'mydatepicker';

@Component({
	selector: 'app-log-list',
	templateUrl: './log-list.component.html',
	providers: [
		LogService,
		HttpModule
	]
})
export class LogListComponent implements OnInit {
	private token;
	public permissoes: any[] = [];
	public logBeginDate; // Create oldest date object possible (1969)
	public logEndDate; // create date object with now Date
	public logUser = '';
	public resultCount: number = 0;
	public currentPage: number = 0;
	public pageLogs: any[] = [];
	private resultsPerPage = globalConst.paginationSkip;

	private today = moment();
	
		//Option to datepicker
		private myDatePickerOptions: IMyDpOptions = {
			// other options...
			dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
			monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
			dateFormat: 'dd/mm/yyyy',
			showTodayBtn: false,
			//disableSince: {year: this.today.year(), month: this.today.month()+1, day: this.today.date()},
			//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
			//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
			//editableDateField: false,
			height: "30px"
		};


	constructor(private logService: LogService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchLog();
	}

	searchLog() {
		//format to required date type and add 1 day to get the right period
		const dateBegin = this.logBeginDate? moment(this.logBeginDate["jsdate"]).format("YYYY-MM-DD HH:mm:ss"):null;
		const dateEnd = this.logEndDate? moment(this.logEndDate["jsdate"]).add(1, 'd').format("YYYY-MM-DD HH:mm:ss"):null;
		const user = this.logUser == ''? null:this.logUser;

		this.logService.getLogs(dateBegin, dateEnd, this.logUser, this.currentPage).subscribe(result => {
			console.log(result);
			this.pageLogs = result.Result; //store all logs
			this.resultCount = result.Count; //count the total result
		});
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchLog();
	}

}


// WEBPACK FOOTER //
// ./src/app/log/component/log-list/log-list.component.ts